import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output, ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import {Consumer} from '@emm/core/models/consumer.model';
import {LocationSet} from '@emm/core/models/location-set.model';
import {MenuSearchComponent} from '@emm/menu/components/menu-search/menu-search.component';
import {BehaviorSubject} from 'rxjs';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-menu-header-global',
    styleUrls: ['./menu-header-global.component.scss'],
    templateUrl: './menu-header-global.component.html',
    standalone: false
})
export class MenuHeaderGlobalComponent implements OnInit {

    @Input() isEmpty: boolean;
    @Input() readonly: boolean;
    @Input() selectedConsumer: Consumer;
    @Input() selectedLocation: LocationSet;

    @Output() add = new EventEmitter();
    @Output() sort = new EventEmitter();
    @Output() sortByName = new EventEmitter();
    @Output() sortByTag = new EventEmitter();
    @Output() expandAll = new EventEmitter<boolean>();
    @Output() expandChecked = new EventEmitter<boolean>();
    @Output() searchButtonClicked = new EventEmitter<string>();
    @Output() clearSearchButtonClicked = new EventEmitter<void>();

    @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;
    @ViewChild(MenuSearchComponent) menuSearch: MenuSearchComponent;

    $expandAll: boolean;
    $expandChecked; boolean;
    isSearchMode$ = new BehaviorSubject<boolean>(false);

    constructor() {}

    ngOnInit(): void {}

    handleExpandAll(): void {
        this.$expandAll = !this.$expandAll;
        this.expandAll.emit(this.$expandAll);
    }

    handleExpandChecked(): void {
        this.$expandChecked = !this.$expandChecked;
        this.expandChecked.emit(this.$expandChecked);
    }

    openMenu(event: Event) {
        event.preventDefault();
        this.matMenuTrigger.openMenu();
    }

    handleSearchButtonClicked(filter: string) {
        this.isSearchMode$.next(true);
        this.searchButtonClicked.next(filter);
    }

    handleClearSearchButtonClicked() {
        this.isSearchMode$.next(false);
        this.menuSearch.searchFilter = '';
        this.clearSearchButtonClicked.next();
    }
}
